export const BOOK_CALL_ROUTE_TYPES = {
    CALENDAR_EMBED: 'calendar_embed',
    EXTERNAL_REDIRECT: 'external_redirect',
    TRANSITION_MODAL: 'transition_modal',
}

export const BOOK_CALL_DEFAULT_THANK_YOU_PATH =
    '/thank-you-for-scheduling-your-call'

export const BOOK_CALL_DESTINATIONS = {
    GREG: 'https://meetings.hubspot.com/greg982',
    JAKE: 'https://meetings.hubspot.com/mnemer/homeservices',
    KAYLA_GENERIC:
        'https://meetings.hubspot.com/kaylabragg/round-robin-olm-meeting-link',
    INVELO_ONBOARDING: 'https://meetings.hubspot.com/kyle1256/demowithinvelo',
    JAKE_MICHAEL: 'https://meetings.hubspot.com/kaylabragg/programs-mm',
    OLC: 'https://openletterconnect.com/',
    OLC_SIGNUP: 'https://app.openletterconnect.com/signup',
    INVELO: 'https://inveloapp.com/',
}

export const BOOK_CALL_HUBSPOT_FIELD_NAMES = {
    industry: 'what_industry_are_you_part_of_',
    budget: 'what_is_your_monthly_marketing_budget_',
    mailingList: 'mailing_list',
}

export const BOOK_CALL_BUDGET_OPTIONS = [
    'Less than $1,000',
    '$1,000-$5,000',
    '$5,000-$10,000',
    '$10,000-$20,000',
    '$20,000-$50,000',
    '$50,000-$75,000',
    '$75,000-$150,000',
    '$150,000+',
]

export const BOOK_CALL_MEETING_BUDGET_VALUE_MAP = {
    'Less than $1,000': '$1-$500',
    '$1,000-$5,000': '$500-$3,000',
    '$5,000-$10,000': '$5,000-$10,000',
    '$10,000-$20,000': '$10,000+',
    '$20,000-$50,000': '$20,000-$50,000',
    '$50,000-$75,000': '$50,000-$75,000',
    '$75,000-$150,000': '$75,000-$150,000',
    '$150,000+': '$150,000+',
}

export const BOOK_CALL_MAILING_LIST_OPTIONS = [
    'I need a mailing list',
    'My mailing list is ready to go!',
]

export const BOOK_CALL_ROUTE_CONFIG = {
    real_estate: {
        under_1k: {
            need_list: {
                type: BOOK_CALL_ROUTE_TYPES.TRANSITION_MODAL,
                destinationUrl: BOOK_CALL_DESTINATIONS.INVELO,
                primaryCtaUrl: BOOK_CALL_DESTINATIONS.INVELO_ONBOARDING,
                secondaryDestinationUrl: BOOK_CALL_DESTINATIONS.OLC_SIGNUP,
                transitionModal: 'invelo',
                thankYouPath: null,
            },
            ready_list: {
                type: BOOK_CALL_ROUTE_TYPES.TRANSITION_MODAL,
                destinationUrl: BOOK_CALL_DESTINATIONS.OLC_SIGNUP,
                transitionModal: 'olc',
                thankYouPath: null,
            },
        },
        mid_1k_to_9k: {
            type: BOOK_CALL_ROUTE_TYPES.CALENDAR_EMBED,
            destinationUrl: BOOK_CALL_DESTINATIONS.KAYLA_GENERIC,
            thankYouPath: BOOK_CALL_DEFAULT_THANK_YOU_PATH,
        },
        high_10k_to_20k: {
            type: BOOK_CALL_ROUTE_TYPES.CALENDAR_EMBED,
            destinationUrl: BOOK_CALL_DESTINATIONS.JAKE,
            thankYouPath: BOOK_CALL_DEFAULT_THANK_YOU_PATH,
        },
        high_20k_plus: {
            type: BOOK_CALL_ROUTE_TYPES.CALENDAR_EMBED,
            destinationUrl: BOOK_CALL_DESTINATIONS.JAKE,
            thankYouPath: BOOK_CALL_DEFAULT_THANK_YOU_PATH,
        },
    },
    other: {
        under_1k: {
            type: BOOK_CALL_ROUTE_TYPES.TRANSITION_MODAL,
            destinationUrl: BOOK_CALL_DESTINATIONS.OLC_SIGNUP,
            transitionModal: 'olc',
            thankYouPath: null,
        },
        mid_1k_to_9k: {
            type: BOOK_CALL_ROUTE_TYPES.CALENDAR_EMBED,
            destinationUrl: BOOK_CALL_DESTINATIONS.KAYLA_GENERIC,
            thankYouPath: BOOK_CALL_DEFAULT_THANK_YOU_PATH,
        },
        high_10k_to_20k: {
            type: BOOK_CALL_ROUTE_TYPES.CALENDAR_EMBED,
            destinationUrl: BOOK_CALL_DESTINATIONS.JAKE_MICHAEL,
            thankYouPath: BOOK_CALL_DEFAULT_THANK_YOU_PATH,
        },
        high_20k_plus: {
            type: BOOK_CALL_ROUTE_TYPES.CALENDAR_EMBED,
            destinationUrl: BOOK_CALL_DESTINATIONS.JAKE_MICHAEL,
            thankYouPath: BOOK_CALL_DEFAULT_THANK_YOU_PATH,
        },
    },
}

export const isPlaceholderValue = (value) =>
    typeof value === 'string' && value.startsWith('#TODO_')

export const isRealEstateIndustry = (industry) => industry === 'Real Estate'

export const normalizeBudgetBucket = (budget) => {
    if (budget === 'Less than $1,000') {
        return 'under_1k'
    }

    if (budget === '$1,000-$5,000' || budget === '$5,000-$10,000') {
        return 'mid_1k_to_9k'
    }

    if (budget === '$10,000-$20,000') {
        return 'high_10k_to_20k'
    }

    if (
        budget === '$20,000-$50,000' ||
        budget === '$50,000-$75,000' ||
        budget === '$75,000-$150,000' ||
        budget === '$150,000+'
    ) {
        return 'high_20k_plus'
    }

    return null
}

export const getMeetingBudgetPrefillValue = (budget) =>
    BOOK_CALL_MEETING_BUDGET_VALUE_MAP[budget] || budget

export const resolveBookCallRoute = ({ industry, budget, mailingList }) => {
    const industryKey = isRealEstateIndustry(industry) ? 'real_estate' : 'other'
    const budgetBucket = normalizeBudgetBucket(budget)

    if (!budgetBucket) {
        return null
    }

    if (industryKey === 'real_estate' && budgetBucket === 'under_1k') {
        const listKey =
            mailingList === BOOK_CALL_MAILING_LIST_OPTIONS[0]
                ? 'need_list'
                : 'ready_list'

        return {
            ...BOOK_CALL_ROUTE_CONFIG.real_estate.under_1k[listKey],
            budgetBucket,
            industryKey,
            listKey,
        }
    }

    return {
        ...BOOK_CALL_ROUTE_CONFIG[industryKey][budgetBucket],
        budgetBucket,
        industryKey,
        listKey: null,
    }
}

export const buildBookCallMeetingUrl = ({
    meetingBaseUrl,
    firstName,
    lastName,
    email,
    budget,
    industry,
    mailingList,
}) => {
    const meetingUrl = new URL(meetingBaseUrl)
    const meetingBudgetValue = getMeetingBudgetPrefillValue(budget)

    meetingUrl.searchParams.set('embed', 'true')
    meetingUrl.searchParams.set('firstName', firstName)
    meetingUrl.searchParams.set('firstname', firstName)
    meetingUrl.searchParams.set('lastName', lastName)
    meetingUrl.searchParams.set('lastname', lastName)
    meetingUrl.searchParams.set('email', email)
    meetingUrl.searchParams.set(
        BOOK_CALL_HUBSPOT_FIELD_NAMES.industry,
        industry,
    )
    meetingUrl.searchParams.set(
        BOOK_CALL_HUBSPOT_FIELD_NAMES.budget,
        meetingBudgetValue,
    )
    if (mailingList) {
        meetingUrl.searchParams.set(
            BOOK_CALL_HUBSPOT_FIELD_NAMES.mailingList,
            mailingList,
        )
    }
    return meetingUrl.toString()
}

export const buildBookCallHubspotFields = ({
    firstName,
    lastName,
    email,
    industry,
    budget,
    mailingList,
}) => {
    const fields = [
        { name: 'firstname', value: firstName },
        { name: 'lastname', value: lastName },
        { name: 'email', value: email },
        {
            name: BOOK_CALL_HUBSPOT_FIELD_NAMES.industry,
            value: industry,
        },
        {
            name: BOOK_CALL_HUBSPOT_FIELD_NAMES.budget,
            value: budget,
        },
    ]

    if (mailingList) {
        fields.push({
            name: BOOK_CALL_HUBSPOT_FIELD_NAMES.mailingList,
            value: mailingList,
        })
    }

    return fields
}

export const getUnresolvedBookCallConfigItems = () => []

export const hasUnresolvedBookCallRouteConfig = () =>
    getUnresolvedBookCallConfigItems().length > 0
